export default __webpack_public_path__ + "static/media/intro_02.cc0e3948.png";